function sortByName(array) {
    return array.sort((a, b) => {
        let nameA = a.properties.name;
        let nameB = b.properties.name;
        let returnVal;

        if (nameA.slice(0, 4).toUpperCase() === 'THE ') {
            nameA = nameA.slice(4, nameA.length);
        }

        if (nameB.slice(0, 4).toUpperCase() === 'THE ') {
            nameB = nameB.slice(4, nameB.length);
        }

        if (nameA < nameB) {
            returnVal = -1;
        }
        if (nameA > nameB) {
            returnVal = 1;
        }
        // Must have return at end to pass ESLint
        return returnVal;
    });
}

function sortByFeaturedOrder(array) {
    return array.sort((a, b) => {
        const orderNumA = Number(a.properties.featured_order);
        const orderNumB = Number(b.properties.featured_order);
        let returnVal;

        if (orderNumA < orderNumB) {
            returnVal = -1;
        }
        if (orderNumA > orderNumB) {
            returnVal = 1;
        }
        // Must have return at end to pass ESLint
        return returnVal;
    });
}

function sortByDistance(array) {
  return array.sort((a, b) => {
    const distanceNumA = a.properties.tilequery.distance;
    const distanceNumB = b.properties.tilequery.distance;
    let returnVal;

    if (distanceNumA < distanceNumB) {
        returnVal = -1;
    }
    if (distanceNumA > distanceNumB) {
        returnVal = 1;
    }
    // Must have return at end to pass ESLint
    return returnVal;
  });
}

const filter =
{
    featuredOnly: e => e.properties.is_featured === '1',
    nonFeaturedOnly: e => e.properties.is_featured === '0',
};

const sort = {
    byFeaturedOrder: (a, b) => {
        const orderNumA = Number(a.properties.featured_order);
        const orderNumB = Number(b.properties.featured_order);
        let returnVal;

        if (orderNumA < orderNumB) {
            returnVal = -1;
        }
        if (orderNumA > orderNumB) {
            returnVal = 1;
        }
        // Must have return at end to pass ESLint
        return returnVal;
    },
    byName: (a, b) => {
        let nameA = a.properties.name;
        let nameB = b.properties.name;
        let returnVal;

        if (nameA.slice(0, 4).toUpperCase() === 'THE ') {
            nameA = nameA.slice(4, nameA.length);
        }

        if (nameB.slice(0, 4).toUpperCase() === 'THE ') {
            nameB = nameB.slice(4, nameB.length);
        }

        if (nameA < nameB) {
            returnVal = -1;
        }
        if (nameA > nameB) {
            returnVal = 1;
        }
        // Must have return at end to pass ESLint
        return returnVal;
    },
    byDistance: (a, b) => {
      const distanceNumA = a.properties.tilequery.distance;
      const distanceNumB = b.properties.tilequery.distance;
      let returnVal;

      if (distanceNumA < distanceNumB) {
          returnVal = -1;
      }
      if (distanceNumA > distanceNumB) {
          returnVal = 1;
      }
      // Must have return at end to pass ESLint
      return returnVal;

    }
};

module.exports = {
    Filters: filter,
    Sorts: sort,
    sortByFeaturedOrder,
    sortByName,
    sortByDistance,
};
